export default "__VITE_ASSET__CsGcyIHT__"